/* Install synchronously near the start of <head>, before third-party scripts.
 * Configure data-brand, data-endpoint and data-shop-origin on this script tag.
 * No cookie crosses origins; the short-lived proof is exchanged after consent.
 */
(function () {
  "use strict";
  var script = document.currentScript;
  var brand = script && script.getAttribute("data-brand");
  var endpoint = script && script.getAttribute("data-endpoint");
  var shopOrigin = script && script.getAttribute("data-shop-origin");
  var handoff = null;
  // Remove the complete dedicated fragment synchronously, before any async work.
  if (/^#bx_em_handoff=/.test(window.location.hash)) {
    try { handoff = decodeURIComponent(window.location.hash.slice(15)); } catch (_) { handoff = null; }
    try { window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search); }
    catch (_) { return; }
  }
  if (!/^(bebelux|starkfeld)$/.test(brand || "") || window.location.origin !== shopOrigin) return;
  try {
    var target = new URL(endpoint);
    if (target.protocol !== "https:" || target.username || target.password || target.search || target.hash
      || target.pathname !== "/m/shop/" + brand + "/events") return;
  } catch (_) { return; }
  var key = "stl_em_visitor_" + brand;
  var identity = null;
  var pending = false;
  var ready = false;
  var productReported = false;
  var epoch = 0;
  var originalFetch = window.fetch;
  if (typeof originalFetch !== "function") return;
  function consent() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && privacy.marketingAllowed() === true && privacy.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }
  function privacyReady() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!privacy && typeof privacy.marketingAllowed === "function"
      && typeof privacy.analyticsProcessingAllowed === "function";
  }
  function forget() {
    identity = null;
    try { window.localStorage.removeItem(key); } catch (_) { /* Storage can be disabled. */ }
  }
  function valid() { return identity && typeof identity.visitor === "string" && identity.expiresAt > Date.now(); }
  function report(payload) {
    if (!consent()) { forget(); return; }
    if (!valid()) { forget(); return; }
    originalFetch.call(window, endpoint, { method: "POST", credentials: "omit", referrerPolicy: "no-referrer",
      keepalive: true, headers: { "content-type": "text/plain" },
      body: JSON.stringify({ visitor: identity.visitor, reports: [payload] }) }).catch(function () {});
  }
  function productView() {
    if (!ready || productReported || !valid() || !consent()) return;
    var product = document.querySelector("[data-bx-product-id]");
    if (!product) return;
    productReported = true;
    report({ kind: "product_viewed", productRef: String(product.getAttribute("data-bx-product-id") || ""),
      productUrl: window.location.origin + window.location.pathname,
      productTitle: String(product.getAttribute("data-bx-product-title") || "") });
  }
  function activate() {
    // An API that has not loaded is not a revocation of existing consent.
    if (!privacyReady()) return;
    if (!consent()) { epoch += 1; forget(); return; }
    if (pending) return;
    if (!handoff) {
      try { identity = JSON.parse(window.localStorage.getItem(key)); } catch (_) { identity = null; }
      if (!valid()) forget();
      productView();
      return;
    }
    // A new email identity replaces the old one only after fresh validation.
    forget();
    pending = true;
    var attempt = epoch;
    var proof = handoff;
    handoff = null;
    originalFetch.call(window, endpoint.replace(/\/events$/, "/identify"), {
      method: "POST", credentials: "omit", referrerPolicy: "no-referrer",
      headers: { "content-type": "application/json" }, body: JSON.stringify({ handoff: proof, consent: true })
    }).then(function (response) { return response.ok ? response.json() : null; }).then(function (result) {
      if (attempt !== epoch || !consent()) return;
      identity = result;
      if (!valid()) { forget(); return; }
      try { window.localStorage.setItem(key, JSON.stringify({ visitor: identity.visitor, expiresAt: identity.expiresAt })); }
      catch (_) { /* Session-only memory is sufficient when storage is disabled. */ }
      productView();
    }).catch(function () { forget(); }).finally(function () { pending = false; });
  }
  function cartReport(kind, cart) {
    var items = (Array.isArray(cart.items) ? cart.items : []).slice(0, 100).map(function (item) {
      return { sku: String(item.sku || item.variant_id || ""), title: String(item.product_title || item.title || ""),
        quantity: Number(item.quantity) || 1 };
    });
    report({ kind: kind, cartToken: String(cart.token || ""), itemCount: cart.item_count,
      lineItems: items, totalGross: typeof cart.total_price === "number" ? cart.total_price / 100 : undefined,
      currency: String(cart.currency || ""), cartUrl: window.location.origin + "/cart" });
  }
  function cartChanged(kind) {
    if (!valid() || !consent()) return;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    originalFetch.call(window, root + "cart.js", { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) { if (cart) cartReport(kind, cart); }).catch(function () {});
  }
  function cartKind(input, method) {
    try {
      var url = new URL(typeof input === "string" || input instanceof URL ? input : input.url, window.location.href);
      if (url.origin !== window.location.origin || String(method || "GET").toUpperCase() !== "POST") return null;
      var match = url.pathname.match(/^(?:\/[a-z]{2}(?:-[A-Za-z]{2})?)?\/cart\/(add|change|update|clear)(?:\.js)?$/);
      return match ? (match[1] === "add" ? "cart_added" : "cart_updated") : null;
    } catch (_) { return null; }
  }
  window.fetch = function (input, init) {
    var kind = cartKind(input, init && init.method || input && input.method);
    var result = originalFetch.apply(this, arguments);
    if (kind) result.then(function (response) { if (response.ok) cartChanged(kind); }, function () {});
    return result;
  };
  // Legacy Shopify themes use XMLHttpRequest rather than fetch.
  if (window.XMLHttpRequest) {
    var open = window.XMLHttpRequest.prototype.open;
    var send = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.stlMarketingCartKind = cartKind(url, method);
      return open.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      var request = this;
      var kind = this.stlMarketingCartKind;
      if (kind) this.addEventListener("load", function () { if (request.status >= 200 && request.status < 300) cartChanged(kind); }, { once: true });
      return send.apply(this, arguments);
    };
  }
  document.addEventListener("visitorConsentCollected", activate);
  window.addEventListener("storage", function (event) { if (event.key === key) activate(); });
  var privacyRequested = false;
  function loadPrivacy() {
    activate();
    if (privacyRequested || !window.Shopify || typeof window.Shopify.loadFeatures !== "function") return;
    privacyRequested = true;
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) { if (!error) activate(); });
  }
  function domReady() { ready = true; loadPrivacy(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", domReady, { once: true });
  else domReady();
  // Shopify itself is declared after this deliberately early script.
  window.addEventListener("load", loadPrivacy, { once: true });
})();
